export default __webpack_public_path__ + "static/media/p5.566e5927.jpg";